const initialState = {
    homePageData: null,
    mostPopularVehicles: null,
    upcomingCars: null
};

const homePage = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_HP_DATA_SUCCESS':
            return Object.assign({}, state, {homePageData: {...action.payload}});
        case 'GET_HP_DATA_FAILURE':
            return Object.assign({}, state, {});
        case 'GET_MOST_POPULAR_VEHICLES_SUCCESS':
            return Object.assign({}, state, {mostPopularVehicles: {...action.payload}});
        case 'GET_MOST_POPULAR_VEHICLES_FAILURE':
            return Object.assign({}, state, {});
        case 'GET_UPCOMING_VEHICLES_SUCCESS':
            return Object.assign({}, state, {upcomingCars: {...action.payload}});
        case 'GET_UPCOMING_VEHICLES_FAILURE':
            return Object.assign({}, state, {});
        case 'GET_RECENT_SUCCESS':
            return Object.assign({}, state, {recentAds: {...action.payload}});
        case 'GET_RECENT_FAILURE':
            return Object.assign({}, state, {});
        default:
            return state;
    }
};

export default homePage;


// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/homepage.js